import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import {
  getAnnouncements,
  postAnnouncementView,
} from '../services/announcement-service'

export const useAnnouncementStore = create(
  persist(
    (set, get) => ({
      list: [],
      active: null,
      currentActiveId: null,
      shownIds: [],
      accountId: null,

      // --- Setters ---
      setAccountId: id => set({ accountId: id }),

      setList: list => set({ list }),

      addShown: id => {
        const { shownIds } = get()
        if (shownIds.includes(id)) return
        set({ shownIds: [...shownIds, id] })
      },

      // --- Fetch ---
      fetchAll: async token => {
        try {
          const res = await getAnnouncements({ params: {}, token })
          const sorted = (res.announcements || []).sort(
            (a, b) => b.priority - a.priority
          )

          set({ list: sorted })

          // setelah list terisi -> resolve aktif berikut
          get().resolveNext()
        } catch (err) {
          console.error('Failed to fetch announcements', err)
        }
      },

      // --- Dismiss ---
      dismiss: async (id, token) => {
        try {
          const { currentActiveId } = get()

          // hanya dismiss jika sedang aktif
          if (id !== currentActiveId) return

          if (token) {
            await postAnnouncementView({ id, token })
          }

          get().addShown(id)
        } catch (err) {
          console.error('Failed to dismiss announcement', err)
        }
      },

      // --- Resolve Next ---
      resolveNext: () => {
        const { list, shownIds } = get()

        const next = list.find(a => !shownIds.includes(a.id)) || null

        set({
          active: next,
          currentActiveId: next ? next.id : null,
        })
      },

      // --- Trigger manual ---
      forceShowNext: () => {
        get().resolveNext()
      },
    }),
    {
      name: 'announcement-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: state => ({
        shownIds: state.shownIds,
      }),
    }
  )
)
